import useHeader from './header';

export default function usePage({ store, router }) {
  const { getHeader } = useHeader({ store, router });

  const sendPageViewEvent = () => store.$apiBFF.sendHeaderPersEvent({ type: 'page-view', header: getHeader() });

  return {
    sendPageViewEvent,
  };
}
